import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {ModalService} from 'ngx-dynamic-modal';
import {RedirectLogComponent} from '../../../vna-campaign/modals/redirect-log/redirect-log.component';

@Component({
  selector: 'app-vertical-parameters',
  templateUrl: './vertical-parameters.component.html',
  styleUrls: ['./vertical-parameters.component.scss']
})
export class VerticalParametersComponent implements OnInit {

    @Input() portalService: PortalService;

    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, private campHandler: VnaCampaignService, private alertHandler: AlertaService, private modalService: ModalService) {
        this.form = this.fb.group({
            process_on_click: new FormControl('0', Validators.required),
            use_preview_detector: new FormControl('0', Validators.required),
            pk_target_camp: new FormControl(''),
            redirect_url: new FormControl('', Validators.required),
            domain: new FormControl('', Validators.required)
        });
    }

    save(): void {
        this.submitted = false;

        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };

        this
            .campHandler
            .savePortalService(criteria, 'vertical_parameters', this.portalService.alias, this.form.value)
            .subscribe( result =>{
                this.enabled = false;
                this.alertHandler.addAlert('success','Vertical Parameters have been saved successfully')
            })

    }

    ngOnInit() {
        const verticalData: Object = this.portalService.getConfigKey('vertical_data', {});

        if(verticalData.hasOwnProperty('process_on_click')){
            this.form.controls['process_on_click'].setValue(verticalData['process_on_click']);
        }

        if(verticalData.hasOwnProperty('pk_target_camp')){
            this.form.controls['pk_target_camp'].setValue(verticalData['pk_target_camp']);
        }

        if(verticalData.hasOwnProperty('redirect_url')){
            this.form.controls['redirect_url'].setValue(verticalData['redirect_url']);
        }

        if(verticalData.hasOwnProperty('domain')){
            this.form.controls['domain'].setValue(verticalData['domain']);
        }

        if(verticalData.hasOwnProperty('use_preview_detector')){
            this.form.controls['use_preview_detector'].setValue(verticalData['use_preview_detector']);
        }
    }

    hasVerticalData(): boolean {
        const verticalData: Object = this.portalService.getConfigKey('vertical_data', {});
        return verticalData.hasOwnProperty('redirect_url');
    }

    listRedirects(): void {
        this.modalService.addDynamicComponent(RedirectLogComponent, {'camp_pk' : this.portalService.pkCamp, 'camp_name' : this.portalService.campName});
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/vertical-parameters/vertical-parameters.component.ts